export const formatOrderNumber = (orderNumber?: string | null, compact = false) => {
    const normalized = orderNumber?.trim().replace(/^#+/, '') ?? '';
    if (!normalized) return '—';

    const displayedNumber = compact ? normalized.split('/')[0] : normalized;
    return `#${displayedNumber}`;
};

export const getOrderDateKey = (value?: string | null) => {
    if (!value) return '';

    const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;

    const displayMatch = value.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (displayMatch) return `${displayMatch[3]}-${displayMatch[2]}-${displayMatch[1]}`;

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;

    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const day = String(parsed.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const getTodayDateKey = () => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${now.getFullYear()}-${month}-${day}`;
};

export const getCustomerName = (
    firstName?: string,
    lastName?: string,
    name?: string,
    phoneNumber?: string,
    email?: string,
    emptyFallback = '—',
) => [firstName, lastName]
    .map(value => value?.trim())
    .filter(Boolean)
    .join(' ')
    || name?.trim()
    || phoneNumber?.trim()
    || email?.trim()
    || emptyFallback;
